import { render, staticRenderFns } from "./OrganizationLayout.vue?vue&type=template&id=7d53f65c&scoped=true"
import script from "./OrganizationLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationLayout.vue?vue&type=style&index=0&id=7d53f65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d53f65c",
  null
  
)

export default component.exports